import { Layout } from './Layout';

export class LayoutExt {    
    public Title: string;
    public Mode: string;
    public Layout: Layout;
}